module.exports = __webpack_public_path__ + "img/ring_r_o_null_0@2x.4c6111ef.png";